import Types from 'pages/workouts/util/Types';
// Libraries
import i18next from 'i18next';
// make sure namespace(s) used in this file are loaded for translations
i18next.loadNamespaces(['exercise_types', 'workout']);

const WorkoutOptions = {
    AutoAddRestStepAfterSteps: false,
    CanDeleteStepsInsideRepeater: true,
    CanSortStepsInsideRepeater: true,
    MaxSteps: 100,
    DefaultRepeatIteration: 3,
    LabelAddRepeat: 'workout.add.sets'
};

const isExerciseRequiredBasedOnStepType = (stepType) => {
    if (stepType === Types.StepTypes.Recovery) {
        return false;
    }
    return true;
};

/**
 * Backbone Reference: getStepSelectOptions().StepType in backbone/pages/workouts/workoutConfig/StrengthTrainingWorkoutV2.js
 */
const getStepTypeSelectionItems = () => {
    return [
        {
            value: Types.StepTypes.Warm_Up,
            textKey: 'workout:workout.stepType.warmup'
        },
        {
            value: Types.StepTypes.Interval,
            textKey: 'workout:exercise_label'
        },
        {
            value: Types.StepTypes.Cool_Down,
            textKey: 'workout:workout.stepType.cooldown'
        },
        {
            value: Types.StepTypes.Recovery,
            textKey: 'workout:workout.stepType.recovery'
        },
        {
            value: Types.StepTypes.Rest,
            textKey: 'workout:workout.stepType.rest'
        },
        {
            value: Types.StepTypes.Other,
            textKey: 'workout:workout.step.type.other'
        }
    ];
};

/**
 * Backbone Reference: getDurationOptionsBasedOnStepType in backbone/pages/workouts/workoutConfig/StrengthTrainingWorkoutV2.js
 */
const getDurationTypeSelectionItems = (stepType) => {
    if (stepType === Types.StepTypes.Rest) {
        return [
            {
                value: Types.ConditionTypes.Time,
                textKey: 'units:label_time'
            },
            {
                value: Types.ConditionTypes.Lap_Button,
                textKey: 'workout:workout.step.duration.type.lap.button'
            },
            {
                value: Types.ConditionTypes.Heart_Rate,
                textKey: 'units:label_heart_rate'
            }
        ];
    }
    return [
        {
            value: Types.ConditionTypes.Reps,
            textKey: 'units:label_reps'
        },
        {
            value: Types.ConditionTypes.Time,
            textKey: 'units:label_time'
        },
        {
            value: Types.ConditionTypes.Calories,
            textKey: 'units:label_calories'
        },
        {
            value: Types.ConditionTypes.Lap_Button,
            textKey: 'workout:workout.step.duration.type.lap.button'
        },
        {
            value: Types.ConditionTypes.Heart_Rate,
            textKey: 'units:label_heart_rate'
        }
    ];
};

const RepeatOptions = {
    [Types.RepeatTypes.Iterations]: {
        type: Types.ConditionTypes.Iterations,
        value: Types.RepeatTypes.Iterations,
        text: 'workout.number.of.times',
        unit: 'workout.repeat.title.sets',
        min: 2,
        max: 40,
        defaultValue: 3
    }
};

/**
 * get weight option items for strength workout
 * Backbone Reference:
 * 1. getBenchmarkScalingWeightOptions in backbone/pages/workouts/workoutConfig/StrengthTrainingWorkoutV2.js
 * 2. getSelectOptionValues in backbone/pages/workouts/dropdowns/BenchmarkScalingWeightDropdown.js
 * @param {string | undefined} benchmarkKey
 * @param {string | null} weightWithUnit
 * @param {boolean} exerciseHasBodyWeight
 * @returns {Array} weight option list
 */
const getBenchmarkScalingWeightOptions = (benchmarkKey, weightWithUnit, exerciseHasBodyWeight = false) => {
    let benchmarkScaledText;
    const exerciseTranslation = benchmarkKey ? i18next.t(`exercise_types:exercise_type_${benchmarkKey}`) : '';
    if (benchmarkKey) {
        benchmarkScaledText = weightWithUnit
            ? `(${exerciseTranslation} - ${weightWithUnit})`
            : `(${exerciseTranslation} - ${i18next.t('workout:not_set')})`;
    } else {
        benchmarkScaledText = `(${i18next.t('workout:not_set')})`;
    }
    return [
        {
            value: Types.BenchmarkScalingTypes.Not_Set,
            textKey: exerciseHasBodyWeight ? 'workout:not_set_bodyweight' : 'workout:not_set'
        },
        {
            value: Types.BenchmarkScalingTypes.Manual,
            textKey: 'workout:manual_weight'
        },
        {
            value: Types.BenchmarkScalingTypes.Benchmark_Scaled,
            textKey: 'workout:benchmark_scaled',
            secondText: benchmarkScaledText
        }
    ];
};

export default {
    WorkoutOptions,
    getStepTypeSelectionItems,
    getDurationTypeSelectionItems,
    isExerciseRequiredBasedOnStepType,
    RepeatOptions,
    getBenchmarkScalingWeightOptions
};
